<div class="datetime-picker-modal">
  <mat-dialog-content>
    <form [formGroup]="dateTimeForm" class="datetime-form">
      <mat-calendar
        [selected]="dateTimeForm.get('date')?.value"
        [dateFilter]="dateFilter"
        (selectedChange)="onDateSelected($event)"
      >
      </mat-calendar>
      <div class="time-section">
        <mat-form-field>
          <mat-label>Time</mat-label>
          <input matInput type="time" [formControl]="timeControl" placeholder="HH:MM" />
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!dateTimeForm.valid">
      Submit
    </button>
  </mat-dialog-actions>
</div>
